import * as vp from 'vopay';
import { Box, Select, TextField, DateRangePicker } from 'vopay';
import { FunctionComponent, useState } from 'react';
import styles from './ApprovalList.module.scss';
import { useTranslation } from 'react-i18next';

import { Button } from 'UI';

type ApprovalListSearchParams = {
  currency: string;
  searchTerm: string;
  timeRange: [vp.Timestamp, vp.Timestamp];
};

type SearchFormProps = {
  currency: string;
  searchTerm: string;
  initialTimeRange: [vp.Timestamp, vp.Timestamp];
  hasInvalidEndDate?: boolean;
  shouldShowEndDateError?: boolean;
  setShouldShowEndDateError?: (event: boolean) => void;
  search: (searchParams: ApprovalListSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const ApprovalListSearchForm: FC = ({
  currency,
  searchTerm,
  hasInvalidEndDate,
  shouldShowEndDateError,
  setShouldShowEndDateError,
  initialTimeRange,
  search,
}: SearchFormProps) => {
  const [currentCurrency, setCurrentCurrency] = useState<string>(currency);
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>(searchTerm);
  const [timeRange, setTimeRange] = useState<[vp.Timestamp, vp.Timestamp]>(initialTimeRange);

  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.ApprovalList' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const currencyOptions = [
    { value: 'CAD', label: 'CAD' },
    { value: 'USD', label: 'USD' },
  ];

  return (
    <Box flx="row" gap="sm" wrap="wrap">
      <div className={styles.datePickerContainer}>
        <DateRangePicker
          onChange={(range) => {
            setTimeRange(range);
          }}
          initialTime={initialTimeRange}
          hasInvalidEndDate={hasInvalidEndDate}
          shouldShowEndDateError={shouldShowEndDateError}
          setShouldShowEndDateError={setShouldShowEndDateError}
          triggerVariant="outlineShadow"
        />
      </div>
      <Box width="200px">
        <Select
          version="2"
          placeholder={t('Search.currencyPlaceholder')}
          options={currencyOptions}
          name="currency"
          value={currentCurrency}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentCurrency(e.target.value);
          }}
        />
      </Box>
      <Box maxwidth="180px">
        <TextField
          key="AccountSearchKeyword"
          name="AccountSearchKeyword"
          placeholder={t('Search.keywordPlaceholder')}
          value={currentSearchTerm}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentSearchTerm(e.target.value);
          }}
          variant="outlineShadow"
        />
      </Box>
      <Button
        id="search-verify"
        size="small"
        colorScheme="primary"
        onClick={() => {
          search({
            currency: currentCurrency,
            searchTerm: currentSearchTerm,
            timeRange,
          });
        }}
      >
        {tGlobal('Buttons.search')}
      </Button>
    </Box>
  );
};

export default ApprovalListSearchForm;
